import { makeCompanyUrl } from "@/helpers/jobs";
import { EarlyApplicant, Zap } from "@monsterindia/global-ui-components";
import React from "react";

import {
  getApplicantCountText,
  getFormattedFreshness,
  renderBadge,
} from "@/components/single-page-registration/job-detail/common";

const JobHeader = ({ jobData, isMobile }: any) => {
  const {
    companyName = "",
    companyId = 0,
    title,
    hideCompanyName,
    redirectUrl = "",
    totalApplicants = 0,
    freshness = 0,
    earlyApplicant = false,
    isMicrosite,
    micrositeUrl,
  } = jobData;
  const showCompanyName = !hideCompanyName && companyName;

  const companyUrl = makeCompanyUrl(
    companyId,
    companyName,
    isMicrosite,
    micrositeUrl,
  );
  const bulletTexts = [
    getFormattedFreshness(freshness),
    getApplicantCountText(totalApplicants),
  ];
  const jobTitleSection = title && (
    <div className="mt-4 flex items-center justify-between md:!mt-0">
      <h1 className="text-content-primary text-lg font-bold leading-[26px] md:!text-2xl md:!leading-9">
        {title}
      </h1>
    </div>
  );
  const jobCompanySection = (
    <div className="text-content-secondary md:!text-content-primary -mt-1 line-clamp-2 text-base font-normal leading-6 md:!text-lg md:!leading-[26px]">
      {showCompanyName ? (
        <a
          href={companyUrl}
          target="_blank"
          className="line-clamp-2 text-sm font-normal underline md:!text-base"
        >
          {companyName}
        </a>
      ) : (
        "Company name confidential"
      )}
    </div>
  );

  const jobLabelSection = (
    <ul className="!ml-0 mt-6 flex flex-row flex-wrap items-center gap-2 text-xs md:mt-0 md:!text-sm">
      {renderBadge(
        earlyApplicant || totalApplicants <= 50,
        EarlyApplicant,
        "Early Applicant",
      )}
      {renderBadge(!redirectUrl, Zap, "Quick Apply")}
      {bulletTexts.map(
        (text, index) =>
          text && (
            <li key={index} className="text-content-tertiary ml-3 list-disc">
              {text}
            </li>
          ),
      )}
    </ul>
  );
  return (
    <div className="flex flex-col gap-2 p-4 md:!mt-2 md:!p-6">
      {jobTitleSection}
      {jobCompanySection}
      {jobLabelSection}
    </div>
  );
};

export default JobHeader;
